"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShadeRoot = exports.ShadeClearIcon = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _types = require("./types");
var _utils = require("./utils");
const ShadeRoot = exports.ShadeRoot = (0, _mui.styled)('span', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  currentShade,
  isClickable,
  shade,
  size,
  theme
}) => {
  const isCurrent = currentShade?.productCode === shade.productCode;
  const background = (0, _utils.getShadeBackground)(shade, theme);
  const border = (0, _utils.getShadeBorder)(background, theme);
  const shadeRootSize = (0, _utils.getShadeRootSize)(size, border, isCurrent);
  const style = {
    background,
    backgroundSize: 'cover',
    border,
    borderRadius: '50%',
    boxSizing: 'content-box',
    cursor: isClickable ? 'pointer' : 'default',
    position: 'relative',
    display: size === _types.ShadeSize.Inline ? 'inline-block' : 'flex',
    height: shadeRootSize,
    width: shadeRootSize
  };
  if (isCurrent) {
    style.boxShadow = _mui.SHADOW_LEVEL1;
    style['&::before'] = {
      border: '1px solid transparent',
      borderRadius: '50%',
      boxShadow: `inset 0 0px 0 2px ${(0, _utils.getBoxShadow)(background, theme)}`,
      content: '""',
      display: 'block',
      height: 'calc(100% - 2px)',
      position: 'absolute',
      width: 'calc(100% - 2px)'
    };
  }
  return style;
});
const ShadeClearIcon = exports.ShadeClearIcon = (0, _mui.styled)(_icons.Clear, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['size', 'shade'])
})(({
  shade,
  size,
  theme
}) => ({
  color: (0, _utils.getShadeClearIconColor)(shade, theme),
  alignSelf: 'center',
  margin: '0 auto',
  width: (0, _utils.getShadeClearIconSize)(size),
  height: (0, _utils.getShadeClearIconSize)(size)
}));
